/* eslint-disable react/prop-types */

import { useEffect } from "react";
import { useSelector } from "react-redux";

const ChatBotComponent = () => {
  const authSlice = useSelector((state) => state.auth);

  const generateChatBot = () => {
    if (!Array.isArray(window.qbOptions)) {
      window.qbOptions = [];
    }
    window.qbOptions.push({
      baseUrl: "https://botsrv2.com",
      use: "A7VaDrlNy9bB6xgO/8qJgArRzl9rdvoR9",
    });

    // Crear y añadir el script al DOM
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://static.botsrv2.com/website/js/widget2.js";
    script.crossOrigin = "anonymous";
    script.defer = true;
    script.setAttribute("data-no-minify", "1");
    script.setAttribute("data-cfasync", "false");
    script.id = "bot-widget-script";
    document.body.appendChild(script);
    return script;
  };

  useEffect(() => {
    // Configuración inicial
    if (!authSlice.configCatUser?.features?.chatbot) return;
    generateChatBot();
  }, [authSlice]);

  // dismount logic needs to be at the login component, maybe a custom hook could help?
  // useEffect(() => {
  //   const scriptList = Array.from(
  //     document.querySelectorAll("script[type='text/javascript']")
  //   );
  //   const testScript = scriptList.find(
  //     (script) => script.id === "bot-widget-script"
  //   );
  //   if (!authSlice) testScript.parentNode.removeChild(testScript);
  // }, [authSlice]);

  return null; // Este componente no renderiza nada visible
};

export default ChatBotComponent;
